var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"opacity":"0"},attrs:{"id":"page-frame"}}),(_vm.showLoader)?_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }